import { useEffect, useState } from "react";

export function useCountdown(expiresAt) {
  const [remaining, setRemaining] = useState(() => calc(expiresAt));

  useEffect(() => {
    if (!expiresAt) return;
    const t = setInterval(() => setRemaining(calc(expiresAt)), 1000);
    return () => clearInterval(t);
  }, [expiresAt]);

  return remaining;
}

function calc(expiresAt) {
  if (!expiresAt) return null;
  const end = new Date(expiresAt).getTime();
  const diff = end - Date.now();
  if (diff <= 0) return { expired: true, label: "Expired" };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  let label;
  if (d > 0) label = `${d}d ${h}h ${m}m`;
  else if (h > 0) label = `${h}h ${m}m ${s}s`;
  else label = `${m}m ${s}s`;
  return { expired: false, label, d, h, m, s };
}
